<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card
        :title="title"
        color="primary"
      >
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContact',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: '경기도 광명시 일직로 43, GIDC B동 901호<br>(일직동)<br>주식회사 오라스코프',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: 'Tel : 02-2686-8400<br>Fax: 02-6280-9862',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'orascope@orascope.net',
        },
        {
          icon: 'mdi-account-multiple',
          title: 'Sale',
          text: 'sales) 김동수 이사<br>dongsu.kim@cloudovis.com<br>02) 499-2003',
        },
      ],
    }),
  }
</script>
